import { useEffect, useState } from 'react';

type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastMessage {
  id: string;
  text: string;
  type: ToastType;
}

type Listener = (msg: ToastMessage) => void;
const listeners = new Set<Listener>();

export const toast = {
  success: (text: string) => {
    emit(text, 'success');
  },
  error: (text: string) => {
    emit(text, 'error');
  },
  warning: (text: string) => {
    emit(text, 'warning');
  },
  info: (text: string) => {
    emit(text, 'info');
  },
};

function emit(text: string, type: ToastType) {
  const id = Math.random().toString(36).substring(2, 9);
  const msg: ToastMessage = { id, text, type };
  for (const cb of listeners) {
    cb(msg);
  }
}

export function ToastContainer() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  useEffect(() => {
    const handleToast = (msg: ToastMessage) => {
      setToasts((prev) => [...prev, msg]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== msg.id));
      }, 4000);
    };

    listeners.add(handleToast);
    return () => {
      listeners.delete(handleToast);
    };
  }, []);

  return (
    <div
      className="toast-stack"
      style={{ position: 'fixed', top: '1rem', right: '1rem', zIndex: 9999 }}
    >
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          <div className="toast-description">{t.text}</div>
        </div>
      ))}
    </div>
  );
}
